<template>
  <div
    v-if="tierName && tierName !== 'BRONZE'"
    class="tier-upgrade-container lh-container-custom-gutters small-padding-z margin-bottom-m"
  >
    <div class="grid-x medium-padding-right-s medium-padding-left-s">
      <!-- upgrade description -->
      <div
        class="cell small-12 medium-6 large-6"
        :class="[
          'small-padding-top-s',
          'small-padding-bottom-z',
          'small-padding-right-z',
          'medium-padding-top-s',
          'medium-padding-bottom-s',
          'medium-padding-right-s',
        ]"
      >
        <div>
          <div v-if="isAtDownGradeRisk">
            <!-- downgrade OR Risk -->
            <h6 v-if="tierName !== 'SILVER' && brand === 'mcom'">
              {{ tierValues.riskToSpend }} ${{ tier?.spendToKeepCurrent }} {{ tierValues.riskToCardInCurrentTier }}
            </h6>
            <h4 v-if="tierName !== 'LOYALLIST' && brand === 'bcom'">
              {{ tierValues.riskToSpend }} ${{ tier?.spendToKeepCurrent }} {{ tierValues.riskToCardInCurrentTier }} {{ nextYear }}
            </h4>
          </div>
          <div v-else-if="isInWaitingPeriod">
            <!-- UNLOCKED -->
            <h6 v-if="brand === 'mcom'">
              {{ estimatedTierValues.waitingPeriodInfoHeader }}
            </h6>
            <h4 v-if="brand === 'bcom'">
              {{ estimatedTierValues.waitingPeriodHeading }}
            </h4>
          </div>
          <div v-else>
            <!-- REACHED -->
            <h6 v-if="tierName !== 'PLATINUM' && brand === 'mcom'">
              {{ tierValues.Loyalist }} ${{ tier?.spendToNextUpgrade }} {{ tierValues.loyalistUpgrade }}
            </h6>
            <h6 v-if="tierName === 'PLATINUM' && brand === 'mcom'">{{ tierValues.Loyalist }} {{ tierValues.tierTrackerExpiryDate }}{{ year }}</h6>
            <h4 v-if="tierName !== 'UNL' && brand === 'bcom'">
              {{ tierValues.Loyalist }} ${{ tier?.spendToNextUpgrade }} {{ tierValues.loyalistUpgrade }}
            </h4>
            <h4 v-if="tierName === 'UNL' && brand === 'bcom'">
              {{ tierValues.Loyalist }}
            </h4>
            <p
              v-if="brand === 'bcom'"
              class="body large grey-text"
            >
              {{ tierValues.reachedText?.(tierValues.tierTrackerExpiryDate) }}<span v-if="tierName === 'UNL'">{{ year2Digits }}</span>
            </p>
          </div>
        </div>
        <p
          v-if="isAtDownGradeRisk && brand === 'bcom'"
          class="body medium margin-top-xxs earn-star-passes"
        >
          {{ tierValues.risktToMaintainTierBenefits }}
          {{ tierValues.riskToBenefitsEndDate }} {{ tierValues.tierTrackerExpiryDate }}{{ year2Digits }}
        </p>
        <p
          v-if="isAtDownGradeRisk && brand === 'mcom'"
          class="body medium margin-top-xxs earn-star-passes"
        >
          {{ tierValues.risktToMaintainTierBenefits?.(tierValues.tierTrackerExpiryDate + year) }}
        </p>
        <p
          v-if="isInWaitingPeriod"
          class="body margin-top-xxs"
          :class="brand === 'mcom' ? 'medium earn-star-passes' : 'large grey-text'"
        >
          {{ waitingPeriodDaysOfQualificationContent }}
        </p>
        <a
          v-if="brand === 'mcom'"
          href="#exclusions-title"
          class="small"
          >{{ TIER_TRACKER.LinkTierTooltipExclusion }}</a
        >
        <div
          v-if="brand === 'bcom'"
          class="margin-top-xxs"
        >
          <a
            href="#exclusions-title"
            class="small"
            >{{ CREDITCARD_OFFER.INFO_EXCLUSIONS }}</a
          >
        </div>
      </div>
      <!-- upgrade Progress bar -->
      <div class="cell grid-y small-12 medium-6 large-6 align-center padding-top-s padding-bottom-s">
        <div class="tooltip-wrapper tooltip-alignment align-middle margin-bottom-xxs">
          <h6 class="heavy">${{ tier?.ytdpropSpendDisplay }}</h6>
          <span>&nbsp;/&nbsp;</span>
          <h6
            v-if="isAtDownGradeRisk"
            class="medium"
          >
            ${{ tierThresholdLimitCurrent?.[0]?.value }}
          </h6>
          <h6
            v-else-if="isInWaitingPeriod"
            class="medium"
          >
            ${{ tierThresholdLimitWaitingPeriod?.[0]?.value }}
          </h6>
          <h6
            v-else
            class="medium"
          >
            ${{ tierThresholdLimit?.[0]?.value }}
          </h6>

          <button
            type="button"
            aria-label="Toggletip"
            class="tooltip-small"
            @click="toggle"
          ></button>
          <Toggletip
            id="tt-right"
            ref="tt"
            position="right"
          >
            <div v-if="isInWaitingPeriod">
              <p class="margin-bottom-xxs body medium tier-status-header">
                {{ estimatedTierValues.waitingPeriodInfoHeader }}
              </p>
              <p v-if="blmTopOfListUpgradeEnabled && brand === 'bcom' && estimatedTierCode === 'UNL'">
                {{ estimatedTierValues.infoyouHaveSpent }}
                over ${{ tierThresholdLimit?.[0]?.value }}
                {{ waitingPeriodBenefitsTextContent }}
              </p>
              <p v-else-if="blmTopOfListUpgradeEnabled && brand === 'bcom' && estimatedTierCode === 'TOL'">
                {{ estimatedTierValues.infoyouHaveSpent }} ${{ tier?.ytdpropSpend }}
                {{ estimatedTierValues.keepYourBenefits }}
              </p>
              <p v-else>
                {{ estimatedTierValues.infoyouHaveSpent }} ${{ tier?.ytdpropSpend }}
                {{ waitingPeriodBenefitsTextContent }}
              </p>
              <br v-if="brand === 'bcom' && (tierName === 'TOL' || estimatedTierCode === 'TOL') && estimatedTierCode !== 'UNL'" />
              <p v-if="brand === 'bcom' && (tierName === 'TOL' || estimatedTierCode === 'TOL') && estimatedTierCode !== 'UNL'">
                {{ estimatedTierValues.keepYourBenefitsSpend }}
                <span v-if="tierName !== 'PLATINUM' && tierName !== 'UNL'">${{ tier?.spendToNextUpgrade }}</span>
                {{ estimatedTierValues.keepYourBenefitsWithCard }}
              </p>
              <br v-if="brand === 'bcom'" />
              <span v-if="brand === 'bcom'">{{ upgradeTextContent }}</span>
            </div>
            <div v-else-if="!isInWaitingPeriod && !isAtDownGradeRisk">
              <p class="margin-bottom-xxs body medium tier-status-header">
                {{ tierValues.upgradePeriodInfoHeader }}
              </p>
              <p v-if="brand === 'bcom' && tierName === 'UNL'">
                {{ tierValues.infoyouHaveSpent }}
                over ${{ tierThresholdLimitCurrent?.[0]?.value }}
                {{ waitingPeriodBenefitsTextContent }}
                <br />
                <br />
                <span>{{ upgradeTextContent }}</span>
              </p>
              <p v-else>
                {{ tierValues.infoyouHaveSpent }} ${{ tier?.ytdpropSpend }}
                <span v-if="tierName !== 'PLATINUM' && tierName !== 'UNL'">{{ tierValues.keepYourBenefits }}</span>
                <span v-if="brand === 'bcom' && tierName === 'UNL'">{{ waitingPeriodBenefitsTextContent }}</span>
                <br v-if="brand === 'bcom' && tierName !== 'UNL'" />
                <br v-if="brand === 'bcom' && tierName !== 'UNL'" />
                <span v-if="tierName !== 'PLATINUM' && tierName !== 'UNL'">
                  {{ tierValues.keepYourBenefitsSpend }}${{ tier?.spendToNextUpgrade }}{{ tierValues.keepYourBenefitsWithCard
                  }}<template v-if="brand === 'mcom'">{{ tierValues.tierTrackerExpiryDate }}{{ year }}</template>
                </span>
                <span v-else-if="brand === 'mcom'"> {{ tierValues.tierTrackerExpiryDate }}{{ year }}</span>
                <br v-if="brand === 'bcom'" />
                <br v-if="brand === 'bcom'" />
                <span v-if="brand === 'bcom' && (tierName === 'UNL' || tierName === 'TOL')">{{ upgradeTextContent }}</span>
              </p>
            </div>
            <div v-else-if="isAtDownGradeRisk">
              <p class="margin-bottom-xxs body medium tier-status-header">
                {{ tierValues.riskPeriodInfoHeader }} <span v-if="brand === 'mcom'">{{ nextYear }}</span>
              </p>
              <p>
                {{ tierValues.infoyouHaveSpent }} ${{ tier?.ytdpropSpend }} {{ tierValues.riskToSpendaTotal
                }}<span v-if="brand === 'mcom'"> ${{ tier?.spendToKeepCurrent }}</span>
                <br v-if="brand === 'bcom'" />
                <br v-if="brand === 'bcom'" />
                {{ tierValues.riskToSpendInTotal }} <span v-if="brand === 'mcom'"> {{ year }}&nbsp;</span>
                <span v-else>{{ nextYear }}</span>
                <span v-if="isAtDownGradeRisk && brand === 'mcom'">
                  {{ tierValues.riskToStayThroughTier?.(tierThresholdLimitCurrent?.[0]?.value) }}
                </span>
                <span v-else-if="isAtDownGradeRisk && brand === 'bcom'">
                  {{ tierValues.riskToStayThroughTier?.(tier?.spendToKeepCurrent) }}
                </span>
                <span v-else>{{ tierValues.riskToStayThroughTier?.(tier?.spendToNextUpgrade) }}</span>
                <span v-if="brand === 'mcom'">{{ nextYear }}</span>
                <br v-if="brand === 'bcom'" />
                <br v-if="brand === 'bcom'" />
                <span v-if="brand === 'bcom'">{{ tierValues.riskResetText }}</span>
              </p>
            </div>
            <div
              v-if="brand === 'mcom'"
              class="margin-top-xxs"
            >
              <a
                href="#exclusions-title"
                class="link-style tier-status-header"
                tabindex="0"
                >{{ TIER_TRACKER.LinkTierTooltipExclusion }}</a
              >
            </div>
          </Toggletip>
        </div>
        <ProgressBar
          v-if="isInWaitingPeriod"
          :value="trackerPercentage"
          :tier="estimatedTierValues.loyaltyTracker"
        />
        <ProgressBar
          v-else
          :value="trackerPercentage"
          :tier="tierValues.loyaltyTracker"
        />
        <div
          v-if="isAtDownGradeRisk"
          class="grid-x small text-right margin-top-xxs tier-status align-middle align-right"
        >
          <div class="upgraded-tier-name">
            {{ iconTitleDownGradeRisk }}
          </div>
          <component :is="loyaltyIconDownGradeRisk" />
        </div>
        <div
          v-else-if="isInWaitingPeriod"
          class="grid-x small text-right margin-top-xxs tier-status align-middle align-right"
        >
          <div class="upgraded-tier-name">
            {{ iconTitleDownGradeRiskWaitingPeriod }}
          </div>
          <component :is="loyaltyIconDownGradeRiskWaitingPeriod" />
        </div>
        <div
          v-else
          class="grid-x small text-right margin-top-xxs tier-status align-middle align-right"
        >
          <div class="upgraded-tier-name">
            {{ iconTitle }}
          </div>
          <component :is="loyaltyIcon" />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="tierName === ''"
    class="tier-upgrade-container lh-container-custom-gutters padding-top-s padding-bottom-m padding-right-s padding-left-s"
  >
    <p class="body medium text-center">
      {{ TIER_TRACKER.TierErrorUpdate }}
    </p>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import ProgressBar from '@nuxt-common/atomic-ui/app/components/progressBar/ProgressBar.vue';
import Toggletip from '@nuxt-common/atomic-ui/app/components/toggletip/Toggletip.vue';
import moment from 'moment';
import { brand, TIER_TRACKER, TIER_NAME, CREDITCARD_OFFER } from '../../config';
import { formatTierName } from '../../utils/formatTierName';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore';
import { useKillswitchesStore } from '../../stores/useKillswitchesStore';

const tt = ref(null);
const loyaltyHub = useLoyaltyHubStore();
const killswitches = useKillswitchesStore();

const summary = computed(() => loyaltyHub.unifiedLoyalty?.points?.loyaltyPointsResponse?.loyaltyInfo || {});
const tier = computed(() => summary.value?.tier || {});
const programs = computed(() => summary.value?.programs || []);
const tierName = computed(() => loyaltyHub?.tierName || '');
const estimatedTierCode = computed(() => loyaltyHub?.estimatedTierCode || '');

const nextTierName = computed(() => tier.value?.tierTrackerInfo?.nextTierStatusName || '');
const currentTierName = computed(() => tier.value?.tierTrackerInfo?.currentTierStatusName || '');
const trackerPercentage = computed(() => {
  const raw = parseFloat(tier.value?.tierTrackerInfo?.tierTrackerPercentage);
  return Number.isFinite(raw) ? Math.min(Math.max(raw, 0), 100) : 0;
});

const tierAttributes = computed(() => programs.value?.[0]?.attributes || []);
const spendThresholdAttributes = computed(() =>
  tierAttributes.value.filter((thresholdLimit) => !thresholdLimit?.type || thresholdLimit.type === 'TIER_SPEND_THRESHOLD'),
);
const tierThresholdLimit = computed(() =>
  spendThresholdAttributes.value.filter((thresholdLimit) =>
    brand === 'bcom' ? thresholdLimit?.name === nextTierName.value : formatTierName(thresholdLimit?.name) === formatTierName(nextTierName.value),
  ),
);
const tierThresholdLimitCurrent = computed(() =>
  spendThresholdAttributes.value.filter((thresholdLimit) =>
    brand === 'bcom'
      ? thresholdLimit?.name === currentTierName.value
      : formatTierName(thresholdLimit?.name) === formatTierName(currentTierName.value),
  ),
);
const waitingPeriodTierTarget = computed(() => formatTierName(brand === 'bcom' ? 'UNL' : 'PLATINUM'));
const tierThresholdLimitWaitingPeriod = computed(() =>
  spendThresholdAttributes.value.filter((thresholdLimit) =>
    brand === 'bcom' ? thresholdLimit?.name?.includes('UNL') : formatTierName(thresholdLimit?.name) === waitingPeriodTierTarget.value,
  ),
);

const formattedNextTierName = computed(() => formatTierName(nextTierName.value));
const formattedCurrentTierName = computed(() => formatTierName(currentTierName.value));
const formattedWaitingPeriodTierName = computed(() => formatTierName(waitingPeriodTierTarget.value));

const iconTitle = computed(() => TIER_NAME[formattedNextTierName.value] || '');
const iconTitleDownGradeRisk = computed(() => TIER_NAME[formattedCurrentTierName.value] || '');
const iconTitleDownGradeRiskWaitingPeriod = computed(() => TIER_NAME[formattedWaitingPeriodTierName.value] || '');

const tierValues = computed(() => TIER_TRACKER.TIER_DETAILS[tierName.value] || {});

const isAtDownGradeRisk = computed(() => !!tier.value?.tierDowngradeRiskFlag);
const isInWaitingPeriod = computed(() => !isAtDownGradeRisk.value && !!(estimatedTierCode.value && estimatedTierCode.value !== tierName.value));

const estimatedTierValues = computed(() => {
  const key = formatTierName(estimatedTierCode.value || (isInWaitingPeriod.value ? nextTierName.value : ''));
  return TIER_TRACKER.TIER_DETAILS[key] || {};
});

const tolUnlimitedEndMonth = computed(() => (tier.value?.bcomFirstHalf ? 'July' : 'January'));
const blmTopOfListUpgradeEnabled = computed(() => killswitches.blmTopOfListUpgradeEnabled === true);

const upgradeTextContent = computed(() => {
  const details = isInWaitingPeriod.value ? estimatedTierValues.value : tierValues.value;
  if (blmTopOfListUpgradeEnabled.value && details?.upgradeTextFC) {
    return details.upgradeTextFC;
  }
  return details?.upgradeText || details?.upgradeTextFC;
});

const waitingPeriodBenefitsTextContent = computed(() => {
  // Reached UNL has no estimatedTierCode, so estimatedTierValues is empty — use current tier copy.
  const details = isInWaitingPeriod.value ? estimatedTierValues.value : tierValues.value;
  if (blmTopOfListUpgradeEnabled.value && details?.waitingPeriodBenefitsFC) {
    return details.waitingPeriodBenefitsFC;
  }
  return details?.waitingPeriodBenefits;
});

const waitingPeriodDaysOfQualificationContent = computed(() => {
  const details = isInWaitingPeriod.value && estimatedTierCode.value === 'UNL' ? estimatedTierValues.value : tierValues.value;
  if (blmTopOfListUpgradeEnabled.value && details?.waitingPeriodDaysOfQualificationFC) {
    return details.waitingPeriodDaysOfQualificationFC;
  }
  return details?.waitingPeriodDaysOfQualification?.(tolUnlimitedEndMonth.value);
});

const loyaltyIcon = computed(() => TIER_TRACKER.TIER_DETAILS[formattedNextTierName.value]?.loyaltyIcon);
const loyaltyIconDownGradeRisk = computed(() => TIER_TRACKER.TIER_DETAILS[formattedCurrentTierName.value]?.loyaltyIconDownGradeRisk);
const loyaltyIconDownGradeRiskWaitingPeriod = computed(
  () => TIER_TRACKER.TIER_DETAILS[formattedWaitingPeriodTierName.value]?.loyaltyIconDownGradeRiskWaitingPeriod,
);

const year = computed(() => moment(tier.value?.tierExpiryDate || undefined).format('YYYY'));
const nextYear = computed(() => parseInt(year.value, 10) + 1);
const year2Digits = computed(() => moment(tier.value?.tierExpiryDate || undefined).format('YY'));

const toggle = (event) => {
  tt.value?.toggle(event);
};

defineExpose({
  upgradeTextContent,
  waitingPeriodBenefitsTextContent,
  waitingPeriodDaysOfQualificationContent,
  estimatedTierValues,
  waitingPeriodTierTarget,
  formattedWaitingPeriodTierName,
  tierThresholdLimitWaitingPeriod,
  blmTopOfListUpgradeEnabled,
  isInWaitingPeriod,
  isAtDownGradeRisk,
  trackerPercentage,
  toggle,
  tt,
});
</script>




<style lang="scss" scoped>
.earn-star-passes {
  color: $gray-1-color;
}
.tier-status-header {
  color: $white;
}
.tier-upgrade-container {
  border-bottom: $hr-thick-gray-spacer;
}

.tooltip-alignment {
  display: flex;
}

.tier-status {
  color: $gray-1-color;
}
.upgraded-tier-name {
  text-transform: capitalize;
}
.lh-container-custom-gutters {
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
}


@import '~@core/csg/src/scss/encodedIcons/bcom/_tooltip-small.scss';
.grey-text {
  color: $gray-1-color;
  font-size: rem-calc(16);
}
.upgraded-tier-name {
  margin-right: rem-calc(4);
}
</style>